module.exports = __webpack_public_path__ + "img/cars-paris-desktop.92eaca6b.png";